export enum NpaperTypographyEnum {
    Heading20 = 'Heading20',
    Heading16 = 'Heading16',
    IconBody18 = 'iconBody18',
    IconBody34 = 'iconBody34',
    IconBody22 = 'iconBody22',
    IconBody14 = 'iconBody14',
}
